export default "__VITE_ASSET__2822f76c__"